/**
 * Class Settings Service
 * Class Types, Subjects, Custom Fields
 */

import api from '../lib/api';

export const classSettingsService = {
  // Class Types
  async getClassTypes() {
    const response = await api.get('/class-types');
    return response.data;
  },

  async createClassType(data) {
    const response = await api.post('/class-types', data);
    return response.data;
  },

  async updateClassType(id, data) {
    const response = await api.put(`/class-types/${id}`, data);
    return response.data;
  },

  async deleteClassType(id) {
    const response = await api.delete(`/class-types/${id}`);
    return response.data;
  },

  // Subjects
  async getSubjects() {
    const response = await api.get('/subjects');
    return response.data;
  },

  async createSubject(data) {
    const response = await api.post('/subjects', data);
    return response.data;
  },

  async updateSubject(id, data) {
    const response = await api.put(`/subjects/${id}`, data);
    return response.data;
  },

  async deleteSubject(id) {
    const response = await api.delete(`/subjects/${id}`);
    return response.data;
  },

  // Custom Field Definitions
  async getCustomFields() {
    const response = await api.get('/class-custom-fields');
    return response.data;
  },

  async createCustomField(data) {
    const response = await api.post('/class-custom-fields', data);
    return response.data;
  },

  async updateCustomField(id, data) {
    const response = await api.put(`/class-custom-fields/${id}`, data);
    return response.data;
  },

  async deleteCustomField(id) {
    const response = await api.delete(`/class-custom-fields/${id}`);
    return response.data;
  }
};
